import moment from 'moment'

export function getCurrentDate() {
  return moment(new Date()).format('YYYY-MM-DD')
}

export function getCurrentDateWithType() {
  return moment(new Date()).format('DD MMM, YYYY')
}

export function getNextYearsDate(year: number) {
  return moment(new Date()).add(year, 'years').format('DD MMM, YYYY')
}

export function parseDate(date) {
  if (date) {
    return moment(date, 'YYYY-MM-DDTHH:mm:ss').format('DD, MMM YYYY HH:mm A')
    // moment(new Date()).add(30, 'years').format('DD MMM, YYYY')
  }
  return ''
}
export function formatDate(date) {
  if (date) {
    return moment(date, 'YYYY-MM-DDTHH:mm:ss').format('DD, MMM, YYYY')
    // moment(new Date()).add(30, 'years').format('DD MMM, YYYY')
  }
  return ''
}

export function formatDateYearStarting(inputDate) {
  return moment(inputDate, 'DD-MM-YYYY').format('YYYY-MM-DD')
}

export function formatDateYearLast(inputDate) {
  return moment(inputDate, 'YYYY-MM-DD').format('DD-MM-YYYY')
}

export function formatDateYearInSlash(inputDate) {
  return moment(inputDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
}

export const wait = (msec: number) =>
  new Promise((resolve, _) => {
    setTimeout(resolve, msec)
  })

export const getCurrentDateTimeForApi = () => moment().format('YYYY-MM-DDTHH:mm').toString()

export const getAttendanceBusinessDate = () => moment().format('YYYY-MM-DD')

export const buildAttendanceIdempotencyKey = (action: string) =>
  `attendance-${action}-${getAttendanceBusinessDate()}-${Date.now()}`
